// AbMapFieldsTab — Liste aller Feld-Karten (EBELN…WAERS). Duenne Wrapper-Komponente, damit
// AbMappingEditor.js schlank bleibt (500-LOC-Regel).

import React from 'react';
import { FIELDS } from './rulesetModel';
import AbMapFieldCard from './AbMapFieldCard';

const AbMapFieldsTab = ({ isDarkMode, t, form, expandedField, onToggleExpand, onFieldChange, pick, onPick, preview }) => {
  const textMuted = isDarkMode ? 'text-white/55' : 'text-slate-500';
  return (
    <section className="space-y-2">
      <h3 className={`text-sm font-semibold ${isDarkMode ? 'text-white/80' : 'text-slate-700'}`}>{t('ab.map.fieldsTitle')}</h3>
      <p className={`text-xs ${textMuted}`}>{t('ab.map.fieldsHint')}</p>
      <div className="space-y-2">
        {FIELDS.map((field) => (
          <AbMapFieldCard
            key={field}
            isDarkMode={isDarkMode} t={t} field={field} fm={form.fields[field]} form={form}
            canDelivery={form.strategy === 'blocks' && (field === 'EEIND' || field === 'MENGE')}
            expanded={expandedField === field}
            onToggleExpand={onToggleExpand}
            onFieldChange={(patch) => onFieldChange(field, patch)}
            pick={pick} onPick={onPick}
            preview={preview}
          />
        ))}
      </div>
    </section>
  );
};

export default AbMapFieldsTab;
